/* eslint-disable react/no-array-index-key */
/* eslint-disable react/self-closing-comp */
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import { useState, useEffect } from "react";
import { Modal as ModalAntd, Tooltip, message as messageAntd } from "antd";
import styled from "styled-components";
import { Row, Col } from "react-flexbox-grid";
// import { getLabelStatus } from "constants/index";
import { CloseOutlined, Send } from "assets/svg";
import { useGlobalContext } from "context/GlobalContext";
import { device } from "utils";
import { firebaseDatabase } from "config";
import moment from "moment";

const Modal = styled(ModalAntd)`
  .ant-modal-content .close-modal {
    background: #7c4dff;
    width: 48px;
    height: 48px;
    border-radius: 100%;
    border: 3px solid #7c4dff;
    cursor: pointer;
    z-index: 999999999;

    position: absolute;
    right: 0;
    top: 0;
    margin: -1.5em;
  }

  .ant-modal-content .close-modal img {
    filter: invert(1);
  }

  .ant-modal-content .close-modal:hover {
    transition: all 0.5s 0s;
  }

  .ant-modal-content .close-modal span {
    color: #fff;
    font-size: 2em;
  }
`;

const ContainerChats = styled.div`
  padding: 2em;
  height: 320px;
  overflow: scroll;
  border-radius: 8px;
  border: 2px solid #ddd;
`;

const List = styled.ul`
  margin: 0px;
  padding: 0px;

  li {
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: -0.5px;
    line-height: 28px;
    margin-bottom: 17px;
    list-style: none;
    position: relative;
  }

  li p,
  li caption {
    padding: 0.5em;
    border-radius: 4px;
    margin: 0;
    max-width: 50%;
    min-width: 248px;
  }

  li caption {
    padding: 0;
    font-size: 14px;
  }

  li.agent p {
    background: #e4e6eb;
    color: #111;
  }

  li.user p {
    background: #d8b301;
    color: #fff;
  }

  li.receiver p {
    background: #7c4dff;
    color: #fff;
  }

  li.agent {
    display: grid;
    justify-content: flex-start;
  }

  li.user {
    display: grid;
    justify-content: flex-start;
  }

  li.receiver {
    display: grid;
    justify-content: flex-end;
  }
`;

const StyledSend = styled.button`
  border: transparent;
  width: 42px;
  height: 42px;
  background: #7c4af6;
  padding: 10px;
  border-radius: 100%;
  cursor: pointer;

  img {
    filter: invert(1);
  }
`;

const DivStyled = styled.div`
  margin: 0 auto;
  width: 90%;
  height: 400px;
  @media ${device.md} {
    width: 100%;
    // height: 650px;
  }
  opacity: 0;
  visibility: hidden;
  transition: all 2s ease-out;
  &.loaded {
    opacity: 1;
    visibility: visible;
  }
`;

const getCurrentTypeAndClass = (type) => {
  const data = { username: "", currentClass: "" };
  switch (type) {
    case "USER":
      data.username = "Usuario";
      data.currentClass = "user";
      break;
    case "AGENT":
      data.username = "Agente";
      data.currentClass = "agent";
      break;
    default:
      data.username = "Administrador";
      data.currentClass = "receiver";
      break;
  }

  return data;
};

const NODE = "MESSAGES";

export const ModalChat = (props) => {
  const [chat, setChat] = useState([]);
  const gContext = useGlobalContext();

  const handleClose = () => {
    setChat([]);
    gContext.toggleChatModal(null);
  };

  const orderAndUpdateEntryData = (snapshot) => {
    snapshot.forEach((snap) => {
      const dbMessages = snap.val();
      const data = { response: [] };
      if (dbMessages) {
        data.response = Object.keys(dbMessages).map((key) => ({
          ...dbMessages[key],
          key,
        }));
      }
      setChat(data.response);
    });
  };

  const sendMessage = async (data) => {
    const idDoc = gContext.chat;
    if (idDoc && gContext.currentUser?._id) {
      try {
        console.log(data);
        const response = await firebaseDatabase
          .ref(NODE)
          .child(idDoc)
          .child(gContext.currentUser?._id)
          .push(data);
        return { error: false, response };
      } catch (error) {
        return { error: true, response: error };
      }
    } else {
      const messageError = !gContext.currentUser?._id
        ? "Error al cargar la referencia, recargue la página y vuelva a intentar"
        : "No se ha cargado correctamente el chat, recargue la página y vuelva a intentar";
      messageAntd.error(messageError);

      return { error: true, response: null };
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const message = e.target.message.value || "";
    const data = {
      message,
      time: new Date().getTime(),
      seen: false,
      type: "CLIENT",
      userId: gContext.currentUser?._id,
      userName: `${gContext.currentUser?.name} ${gContext.currentUser?.lastNames}`,
      userPicture: "",
    };

    await sendMessage(data);
    e.target.reset();
  };

  useEffect(() => {
    const getMessages = (reference, id) => {
      if (id) {
        const listener = firebaseDatabase
          .ref(reference)
          .child(`${id}`)
          .orderByChild("time")
          .on("value", (snapshot) => orderAndUpdateEntryData(snapshot));
        return listener;
      }

      return [];
    };

    console.log(gContext.chat);
    const removeListener = getMessages(NODE, gContext.chat);
    return () => removeListener;
  }, [gContext.chat]);

  const title = "Chat de reporte";

  return (
    <Modal
      {...props}
      title={title}
      visible={gContext.chatModalVisible}
      maskClosable={false}
      closable={false}
      footer={false}
    >
      <button type="button" className="close-modal" onClick={handleClose}>
        <img src={CloseOutlined} alt="CloseOutlined" />
      </button>
      <DivStyled className={`${!gContext.chat ? "loading" : "loaded"}`}>
        <Row>
          <Col md={12}>
            <ContainerChats>
              <List>
                {chat.map(({ message, type, time }, key) => {
                  const currentTime = moment(time).fromNow();
                  const { currentClass, username } = getCurrentTypeAndClass(
                    type
                  );

                  const currentTooltip = `${username} - ${currentTime}`;

                  return (
                    <li key={`${message}${key}`} className={currentClass}>
                      <>
                        <Tooltip title={currentTooltip}>
                          <div className="w-100">
                            <p>{message}</p>
                            <caption className="font-size-3">
                              {currentTime}
                            </caption>
                          </div>
                        </Tooltip>
                      </>
                    </li>
                  );
                })}
              </List>
            </ContainerChats>
          </Col>
          <Col md={12} className="pt3">
            <form onSubmit={onSubmit}>
              <Row middle="xs" className="mb2">
                <Col xs={10} md={11} className="mr1">
                  <input
                    name="message"
                    type="text"
                    className="ant-input ant-input-lg"
                    required
                    placeholder="Ingresa tu mensaje"
                  />
                </Col>
                <Col xs={2} md={1} style={{ margin: "0 0 0px -18px" }}>
                  <StyledSend type="submit">
                    <img src={Send} alt="icon" />
                  </StyledSend>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </DivStyled>
    </Modal>
  );
};
